import router from '@/router'
import createYDAPI from '@/utils/api'
import createHTTPClient from '@/utils/api/client'
import i18n from '@/utils/plugins/i18n'
import createPermissionChecker from '@/utils/plugins/permissions'

const ydAPIHTTPClient = createHTTPClient(i18n)

export const ydAPI = createYDAPI(ydAPIHTTPClient, i18n, {})

export const cycloidPlugin = {
  /** @param {import('vue').App} app - The Vue instance. */
  install (app) {
    const permissions = createPermissionChecker(router)
    app.config.globalProperties.$cycloid = {
      permissions,
      ydAPI,
    }
    app.config.globalProperties.$hasRightsTo = permissions.canDisplay
  },
}

export default cycloidPlugin
